var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"builder-mobile-frame",class:{
		'zyro-mb-preview': _vm.isMobileView,
		'zyro-desktop-preview': !(_vm.isMobileView || _vm.isMobileScreen),
		'zyro-mb-preview--framed': _vm.showMockup && _vm.isMobileView
	},style:(_vm.computedStyles)},[_c('div',{ref:"mobileFrame",staticClass:"builder-mobile-frame__preview"},[_vm._t("default")],2),(_vm.showTooltip)?_c('BuilderRibbonTooltip'):_vm._e(),(_vm.isLightboxOpen)?_c('Lightbox',{attrs:{"is-preview-mode":"","is-mobile-view":_vm.isMobileView}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }